import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist
const baseIndex = process.env.VUE_APP_INDEX
const baseLogin = process.env.VUE_APP_LOGIN
whiteList[0] = baseIndex
whiteList[1] = baseLogin

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  const pathStr = to.path
  let pathSub = pathStr.substring(1)
  var systemType = 'SSO'

  if (pathSub.startsWith('baseInfo') || pathSub.startsWith('system') || pathSub.startsWith('base')) {
    systemType = 'system'
  } else {
    if (pathSub.includes('/')) {
      pathSub = pathSub.substring(0, pathSub.indexOf('/'))
      systemType = pathSub
    } else {
      systemType = pathSub
    }
  }
  document.title = getPageTitle(to.meta.title, systemType)
  // document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = (store.getters.roles && store.getters.roles.length > 0) ||
                        (store.getters.permissions && store.getters.permissions.length > 0)
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          // console.log('开始获取用户信息，systemType:', systemType)
          const { permissions, isAdmin } = await store.dispatch('user/getInfo', systemType)
          // console.log('获取用户信息成功，permissions:', permissions)
          // console.info("roles->",roles)

          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', { role: permissions, type: systemType, isadmin: isAdmin })
          // console.log('生成路由成功，accessRoutes:', accessRoutes)
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          console.error('获取用户信息失败:', error)
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next('/login') //
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next('/login') //
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
